import React from 'react'

import Logo from '~/components/logo'
import Media from '~/components/media'
import { useVendor } from '~/hooks'

function Header() {
  const vendor = useVendor()

  return (
    <div className="flex">
      <div className="flex flex-col gap-2">
        <h4 className="text-xl font-bold">{vendor.fiscalName}</h4>
        <h5>{vendor.ruc}</h5>
        <p>{vendor.fiscalAddress}</p>
        <p>Tienda Online: las ventas online no aplican a menores de 18 años</p>
      </div>
      <Media
        desktop={<Logo className="ml-auto" alternative vendor={vendor} size="large" />}
        mobile={<Logo className="ml-auto" alternative vendor={vendor} size="small" />}
      />
    </div>
  )
}

export default Header
